import { Facebook, FileText, ShieldCheck } from "lucide-react";
import { API, FB_URL } from "@/lib/api";
import { ContactButton } from "@/components/ContactButton";

const LEGAL = [
  ["terms", "Terms and Conditions"],
  ["privacy", "Privacy Policy"],
  ["charter", "Our Charter"],
];

export const Footer = () => (
  <footer className="mt-20 bg-[#121E2B] text-[#FDFBF7] relative grain overflow-hidden" data-testid="site-footer">
    <div className="h-2 bg-[#E2705A]" />
    <div className="relative max-w-6xl mx-auto px-5 sm:px-8 py-16 text-center">
      <p className="font-type font-bold text-2xl sm:text-4xl lg:text-5xl uppercase leading-tight" data-testid="slogan-banner">
        If not you. Then who?
        <br />
        If not now. Then when?
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <a
          href={FB_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="facebook-link"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border border-[#8FA58A]/50 text-[#8FA58A] hover:text-[#FDFBF7] hover:border-[#E2705A] hover:bg-[#E2705A] transition-colors font-semibold text-sm"
        >
          <Facebook className="w-4 h-4" /> R.O.A.N Initiative on Facebook
        </a>
        <ContactButton />
      </div>
      <nav className="mt-8 flex flex-wrap items-center justify-center gap-2" data-testid="footer-legal-links">
        {LEGAL.map(([kind, label]) => (
          <a
            key={kind}
            href={`${API}/documents/${kind}/download`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`footer-link-${kind}`}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#FDFBF7]/20 text-[#FDFBF7]/70 hover:text-[#FDFBF7] hover:border-[#E2705A] transition-colors font-type text-xs uppercase tracking-wider"
          >
            <FileText className="w-3.5 h-3.5" /> {label}
          </a>
        ))}
        <a
          href="https://averageaf.com/policy"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-link-shared-policy"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#8FA58A]/60 text-[#8FA58A] hover:text-[#FDFBF7] hover:border-[#E2705A] hover:bg-[#E2705A] transition-colors font-type text-xs uppercase tracking-wider"
        >
          <ShieldCheck className="w-3.5 h-3.5" /> Average AF Shared Policy
        </a>
      </nav>
      <p className="mt-10 text-xs text-[#FDFBF7]/40 font-type">
        © {new Date().getFullYear()} The R.O.A.N Initiative · Repatriation Of A Nation
      </p>
      <p className="mt-2 text-xs text-[#FDFBF7]/50" data-testid="footer-trading-name">
        "The ROAN Initiative" is a registered trading name of the "Average AF Pty Ltd" company.
      </p>
    </div>
  </footer>
);
